import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-202819d1")
const _hoisted_1 = {
  key: 0,
  class: "imageWrapper"
}
const _hoisted_2 = {
  key: 0,
  class: "_backgroundBlur _field"
}
const _hoisted_3 = {
  key: 1,
  class: "filesWrapper"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h4", null, "You found...", -1)
const _hoisted_5 = {
  key: 0,
  class: "_backgroundBlur _field"
}
const _hoisted_6 = { class: "padded" }
const _hoisted_7 = { class: "data" }
const _hoisted_8 = { class: "title" }
const _hoisted_9 = { class: "description" }
const _hoisted_10 = {
  key: 0,
  class: "hint"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h4", null, "Hint", -1)
const _hoisted_12 = {
  key: 1,
  class: "cheats"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "hint"
}
const _hoisted_15 = {
  key: 1,
  class: "hint"
}
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" No location was provided by the developer - this question's answers are: ")
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "_b" }, null, -1)
const _hoisted_18 = { class: "_grid" }
const _hoisted_19 = {
  key: 0,
  class: "input"
}
const _hoisted_20 = {
  key: 0,
  class: "_backgroundBlur _field"
}
const _hoisted_21 = { class: "answers" }
const _hoisted_22 = { class: "answer" }
const _hoisted_23 = {
  key: 0,
  class: "answerText"
}
const _hoisted_24 = { class: "answerMarker _question" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("span", { class: "answerMarker" }, "Answer:", -1)
const _hoisted_26 = { class: "submission" }
const _hoisted_27 = { class: "indicators" }
const _hoisted_28 = {
  key: 0,
  class: "indicator"
}
const _hoisted_29 = { class: "_icon tick" }
const _hoisted_30 = /*#__PURE__*/_createTextVNode(" Correct ")
const _hoisted_31 = { key: 0 }
const _hoisted_32 = {
  key: 1,
  class: "buttons"
}
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" By asking for a hint, you flag this game as ")
const _hoisted_34 = /*#__PURE__*/_createElementVNode("span", { class: "_highlightBack" }, "Hinted", -1)
const _hoisted_35 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_36 = /*#__PURE__*/_createTextVNode(" By skipping, you flag this game as ")
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "_highlightBack" }, "Skipped", -1)
const _hoisted_38 = /*#__PURE__*/_createTextVNode(". ")
const _hoisted_39 = /*#__PURE__*/_createTextVNode(" Skipping the distance measurement step will cost you ")
const _hoisted_40 = { class: "_highlightBack" }
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" to make up for expected time. ")
const _hoisted_42 = { key: 1 }
const _hoisted_43 = { class: "input small" }
const _hoisted_44 = { key: 2 }
const _hoisted_45 = { class: "input small" }
const _hoisted_46 = {
  key: 3,
  class: "notes"
}
const _hoisted_47 = {
  key: 0,
  class: "_backgroundBlur _field"
}
const _hoisted_48 = /*#__PURE__*/_createElementVNode("h4", null, "Notes", -1)
const _hoisted_49 = {
  key: 4,
  class: "attributions"
}
const _hoisted_50 = {
  key: 0,
  class: "_backgroundBlur _field"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("h4", null, "Attributions", -1)
const _hoisted_52 = { class: "index num" }
const _hoisted_53 = { class: "index" }
const _hoisted_54 = ["href"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LazyImage = _resolveComponent("LazyImage")!
  const _component_File = _resolveComponent("File")!
  const _component_IconButton = _resolveComponent("IconButton")!
  const _component_TextInput = _resolveComponent("TextInput")!
  const _component_MovingIcon = _resolveComponent("MovingIcon")!
  const _component_Confirm = _resolveComponent("Confirm")!

  return (
  _ctx.demo || (_ctx.card 
  && _ctx.card.id == _ctx.$store.state.GameView.currentFocus.id 
  && _ctx.$store.state.GameView.lobby.playthrough.currentCard != undefined
  && _ctx.$store.state.GameView.lobby.playthrough.currentCard >= _ctx.$store.state.GameView.currentFocus.index))
    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
        _createElementVNode("div", null, [
          (_ctx.card.image)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                ((_ctx.highlightText && !_ctx.unhideImage) || _ctx.hideAllButFiles)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_2))
                  : _createCommentVNode("", true),
                _createVNode(_component_LazyImage, {
                  class: "image",
                  "data-focus": `${_ctx.card.id}_image`,
                  src: _ctx.card.image,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.focus(_ctx.card.id,'image',null,null)))
                }, null, 8, ["data-focus", "src"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.card.uploads && _ctx.card.uploads.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _hoisted_4,
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.card.uploads, (file) => {
                  return (_openBlock(), _createBlock(_component_File, { file: file }, null, 8, ["file"]))
                }), 256))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: _normalizeClass({
        card:true,
        small: _ctx.small
      })
          }, [
            (_ctx.hideAllButFiles)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("h2", _hoisted_8, _toDisplayString(_ctx.card.title || "Untitled"), 1),
                _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.card.description || "Untitled"), 1)
              ]),
              ((_ctx.demo && _ctx.demoHint) || (_ctx.$store.state.GameView.lobby.playthrough?.cardStatus
          && _ctx.$store.state.GameView.lobby.playthrough?.cardStatus[_ctx.card.id]?.hinted_one))
                ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                    _hoisted_11,
                    _createTextVNode(" " + _toDisplayString(_ctx.card.hint), 1)
                  ]))
                : _createCommentVNode("", true),
              (_ctx.card.maps)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    (_ctx.distanceSkipped || (_ctx.$store.state.GameView.lobby.playthrough?.cardStatus 
              && _ctx.$store.state.GameView.lobby.playthrough?.cardStatus[_ctx.card.id]?.distanceSkipped))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                          (_ctx.card.mapsDistanceLocation)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_14, _toDisplayString(_ctx.card.mapsDistanceLocation), 1))
                            : (_openBlock(), _createElementBlock("p", _hoisted_15, [
                                _hoisted_16,
                                _createElementVNode("ol", null, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.card.questions, (question) => {
                                    return (_openBlock(), _createElementBlock("li", null, _toDisplayString(question.acceptedValues.split(';')[0]), 1))
                                  }), 256))
                                ])
                              ])),
                          _hoisted_17
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_18, [
                      (_ctx.card.mapsDistance && ( !_ctx.distanceSkipped && !(_ctx.$store.state.GameView.lobby.playthrough?.cardStatus 
              && _ctx.$store.state.GameView.lobby.playthrough?.cardStatus[_ctx.card.id]?.distanceSkipped)))
                        ? (_openBlock(), _createBlock(_component_IconButton, {
                            key: 0,
                            clear: true,
                            text: "Skip distance measurement",
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.skipDistance()))
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ], 2)
        ]),
        (_ctx.card.questions.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
              (_ctx.highlightText || _ctx.hideAllButFiles)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_21, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.card.questions, (question, index) => {
                  return (_openBlock(), _createElementBlock("div", _hoisted_22, [
                    ((_ctx.demo && _ctx.demoAnswered) || (_ctx.$store.state.GameView.lobby.playthrough?.cardStatus 
          && _ctx.$store.state.GameView.lobby.playthrough?.cardStatus[_ctx.card.id]?.complete))
                      ? (_openBlock(), _createElementBlock("p", _hoisted_23, [
                          _createElementVNode("h4", _hoisted_24, _toDisplayString(question.question), 1),
                          _createElementVNode("div", null, [
                            _hoisted_25,
                            _createTextVNode(" " + _toDisplayString(question.acceptedValues.split(';')[0]), 1)
                          ])
                        ]))
                      : (_openBlock(), _createBlock(_component_TextInput, {
                          key: 1,
                          label: question.question,
                          alert: question.incorrect,
                          readonly: _ctx.submitted,
                          onChange: ($event: any) => {question['answer'] = $event; question.incorrect=false; _ctx.focus(_ctx.card.id,`question_${index}`,$event,null)},
                          onEnter: _ctx.submit,
                          placeholder: _ctx.$store.state.GameView.devView?'Answers: '+question.acceptedValues.split(';'):'Answer',
                          "data-focus": `${_ctx.card.id}_question_${index}`,
                          onFocus: ($event: any) => (_ctx.focus(_ctx.card.id,`question_${index}`)),
                          onBlur: ($event: any) => (_ctx.focus(_ctx.card.id,`question_${index}`,null,null))
                        }, null, 8, ["label", "alert", "readonly", "onChange", "onEnter", "placeholder", "data-focus", "onFocus", "onBlur"]))
                  ]))
                }), 256))
              ]),
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("div", _hoisted_27, [
                  ((_ctx.demo && _ctx.demoAnswered) || (_ctx.$store.state.GameView.lobby.playthrough?.cardStatus
          && _ctx.$store.state.GameView.lobby.playthrough?.cardStatus[_ctx.card.id]?.complete 
          && _ctx.$store.state.GameView.lobby.playthrough?.cardStatus[_ctx.card.id]?.correct))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                        _createElementVNode("div", _hoisted_29, [
                          _createVNode(_component_MovingIcon, {
                            name: "tick",
                            type: "svg"
                          })
                        ]),
                        _hoisted_30
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.demo && !_ctx.demoAnswered)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                      (!_ctx.demoHint)
                        ? (_openBlock(), _createBlock(_component_IconButton, {
                            key: 0,
                            text: "Hint",
                            white: true,
                            type: "svg",
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.demoHint = true))
                          }))
                        : _createCommentVNode("", true),
                      _createVNode(_component_IconButton, {
                        icon: _ctx.submitted?'loader_spinner':'',
                        loop: _ctx.submitted,
                        autoplay: true,
                        text: "Submit",
                        type: "svg",
                        onClick: _ctx.submit
                      }, null, 8, ["icon", "loop", "onClick"])
                    ]))
                  : (!_ctx.demo)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        (!_ctx.$store.state.GameView.lobby.playthrough.cardStatus
          || (!_ctx.$store.state.GameView.lobby.playthrough.cardStatus[_ctx.card.id]?.hinted_one
          && !_ctx.$store.state.GameView.lobby.playthrough.cardStatus[_ctx.card.id]?.correct && _ctx.card.hint))
                          ? (_openBlock(), _createBlock(_component_IconButton, {
                              key: 0,
                              text: "Hint",
                              white: true,
                              type: "svg",
                              onClick: _ctx.requestHintOne
                            }, null, 8, ["onClick"]))
                          : (_ctx.$store.state.GameView.lobby.playthrough.cardStatus
          && _ctx.$store.state.GameView.lobby.playthrough.cardStatus[_ctx.card.id]?.hinted_one 
          && !_ctx.$store.state.GameView.lobby.playthrough.cardStatus[_ctx.card.id]?.complete)
                            ? (_openBlock(), _createBlock(_component_IconButton, {
                                key: 1,
                                text: "Skip",
                                white: true,
                                type: "svg",
                                onClick: _ctx.requestSkip
                              }, null, 8, ["onClick"]))
                            : _createCommentVNode("", true),
                        (_ctx.$store.state.GameView.lobby.playthrough.cardStatus
          && _ctx.$store.state.GameView.lobby.playthrough.cardStatus[_ctx.card.id]?.complete
          && _ctx.$store.state.GameView.lobby.playthrough.currentCard > _ctx.$store.state.GameView.cards.data.length-1)
                          ? (_openBlock(), _createBlock(_component_IconButton, {
                              key: 2,
                              icon: "forward",
                              text: "To exit",
                              onClick: _ctx.nextCard
                            }, null, 8, ["onClick"]))
                          : (_ctx.$store.state.GameView.lobby.playthrough.cardStatus
          && _ctx.$store.state.GameView.lobby.playthrough.cardStatus[_ctx.card.id]?.complete)
                            ? (_openBlock(), _createBlock(_component_IconButton, {
                                key: 3,
                                icon: "forward",
                                text: "Next",
                                onClick: _ctx.nextCard
                              }, null, 8, ["onClick"]))
                            : (_openBlock(), _createBlock(_component_IconButton, {
                                key: 4,
                                icon: _ctx.submitted?'loader_spinner':'',
                                loop: _ctx.submitted,
                                autoplay: true,
                                text: "Submit",
                                type: "svg",
                                onClick: _ctx.submit
                              }, null, 8, ["icon", "loop", "onClick"]))
                      ]))
                    : _createCommentVNode("", true)
              ]),
              (_ctx.hintRequested)
                ? (_openBlock(), _createBlock(_component_Confirm, {
                    key: 1,
                    onResolve: _cache[3] || (_cache[3] = ($event: any) => (_ctx.approveHint())),
                    onReject: _cache[4] || (_cache[4] = ($event: any) => (_ctx.denyHint()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_33,
                      _hoisted_34,
                      _hoisted_35
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.skipRequested)
                ? (_openBlock(), _createBlock(_component_Confirm, {
                    key: 2,
                    onResolve: _cache[5] || (_cache[5] = ($event: any) => (_ctx.approveSkip())),
                    onReject: _cache[6] || (_cache[6] = ($event: any) => (_ctx.denySkip()))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_36,
                      _hoisted_37,
                      _hoisted_38
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              (_ctx.distanceSkipRequested)
                ? (_openBlock(), _createBlock(_component_Confirm, {
                    key: 3,
                    onResolve: _cache[7] || (_cache[7] = ($event: any) => (_ctx.approveDistanceSkip(_ctx.card.mapsDistanceSkipPenalty || 5))),
                    onReject: _cache[8] || (_cache[8] = ($event: any) => (_ctx.distanceSkipRequested = false))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_39,
                      _createElementVNode("span", _hoisted_40, _toDisplayString(_ctx.card.mapsDistanceSkipPenalty || 5) + " minutes", 1),
                      _hoisted_41
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : (_ctx.$store.state.GameView.lobby?.playthrough?.cardStatus && _ctx.$store.state.GameView.lobby.playthrough?.cardStatus[_ctx.card.id]?.complete)
            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, [
                  _createVNode(_component_IconButton, {
                    icon: "forward",
                    text: "Next",
                    onClick: _ctx.nextCard
                  }, null, 8, ["onClick"])
                ])
              ]))
            : (!_ctx.demo || !_ctx.$store.state.GameView.lobby?.playthrough?.cardStatus)
              ? (_openBlock(), _createElementBlock("div", _hoisted_44, [
                  _createElementVNode("div", _hoisted_45, [
                    _createVNode(_component_IconButton, {
                      icon: "tick",
                      type: "svg",
                      text: "Okay",
                      onClick: _ctx.success
                    }, null, 8, ["onClick"])
                  ])
                ]))
              : _createCommentVNode("", true),
        (!_ctx.demo && (_ctx.$store.state.GameView.lobby?.playthrough?.cardStatus
    && _ctx.$store.state.GameView.lobby?.playthrough?.cardStatus[_ctx.card.id]?.complete
    && _ctx.card.notes))
          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
              (_ctx.highlightText || _ctx.hideAllButFiles)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47))
                : _createCommentVNode("", true),
              _hoisted_48,
              _createTextVNode(" " + _toDisplayString(_ctx.card.notes), 1)
            ]))
          : _createCommentVNode("", true),
        (_ctx.card.attributions)
          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
              (_ctx.highlightText || _ctx.hideAllButFiles)
                ? (_openBlock(), _createElementBlock("div", _hoisted_50))
                : _createCommentVNode("", true),
              _hoisted_51,
              _createElementVNode("table", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.card.attributions, (a, index) => {
                  return (_openBlock(), _createElementBlock("tr", { key: index }, [
                    (a.resource)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createElementVNode("td", _hoisted_52, _toDisplayString(index) + ".", 1),
                          _createElementVNode("td", _hoisted_53, _toDisplayString(a.resource) + ": " + _toDisplayString(a.author) + ". ", 1),
                          _createElementVNode("td", null, [
                            _createElementVNode("a", {
                              target: "_blank",
                              href: a.license
                            }, "License", 8, _hoisted_54)
                          ])
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ], 64))
    : _createCommentVNode("", true)
}